"use strict";

window.App = window.App || {};

/**
 * Deterministic drawer overlay teardown.
 * Invariant: if no overlay-using drawer is open, no .drawer-overlay may remain.
 */
(function () {
	function isStackingPlanTenantDrawerElement(el) {
		return el && (el.id === "stacking_plan_tenant_drawer" || el.getAttribute("data-stacking-plan-drawer") === "true");
	}

	function hasOverlayUsingDrawerOpen() {
		const openDrawers = document.querySelectorAll(".drawer-on");

		for (let i = 0; i < openDrawers.length; i++) {
			if (!isStackingPlanTenantDrawerElement(openDrawers[i])) {
				return true;
			}
		}

		return false;
	}

	function sweepOverlays() {
		if (hasOverlayUsingDrawerOpen()) {
			return;
		}

		const overlays = document.querySelectorAll(".drawer-overlay");
		if (!overlays.length) {
			window.updateBodyScrollLock?.();
			return;
		}

		overlays.forEach(function (overlay) {
			if (overlay && overlay.parentNode) {
				overlay.parentNode.removeChild(overlay);
			}
		});

		window.updateBodyScrollLock?.();
	}

	function bindDrawerHiddenHandlers() {
		if (typeof KTDrawer === "undefined" || typeof KTDrawer.getInstance !== "function") {
			return;
		}

		document.querySelectorAll("[data-kt-drawer]").forEach(function (drawerEl) {
			const drawerInstance = KTDrawer.getInstance(drawerEl);
			if (!drawerInstance || typeof drawerInstance.on !== "function") {
				return;
			}

			drawerInstance.on("kt.drawer.after.hidden", function () {
				sweepOverlays();
			});
		});
	}

	function bindDrawerOnMutationObservers() {
		document.querySelectorAll("[data-kt-drawer]").forEach(function (drawerEl) {
			const observer = new MutationObserver(function () {
				if (!hasOverlayUsingDrawerOpen()) {
					sweepOverlays();
				}
			});

			observer.observe(drawerEl, {
				attributes: true,
				attributeFilter: ["class"],
			});
		});
	}

	function bindOrphanOverlayClick() {
		document.addEventListener("click", function (event) {
			const target = event.target;
			if (!target || !target.classList || !target.classList.contains("drawer-overlay")) {
				return;
			}

			if (hasOverlayUsingDrawerOpen()) {
				return;
			}

			sweepOverlays();
		});
	}

	function init() {
		bindDrawerHiddenHandlers();
		bindDrawerOnMutationObservers();
		bindOrphanOverlayClick();
	}

	function scheduleInit() {
		// Run after KTDrawer.createInstances (also on DOMContentLoaded) has bound instances.
		requestAnimationFrame(function () {
			init();
		});
	}

	window.App.drawers = window.App.drawers || {};
	window.App.drawers.sweepOverlays = sweepOverlays;
	window.App.drawers.hasOverlayUsingDrawerOpen = hasOverlayUsingDrawerOpen;

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", scheduleInit);
	} else {
		scheduleInit();
	}
})();
